<template>
	<div class="bg-white px-3 goods_create" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{ name: 'djgl_ddcl_dfdd' }" style="position: absolute;top: 32px;left: 200px;"><el-button
				size="mini">回到代付订单</el-button></router-link>

		<el-form ref="form" label-width="80px" style="margin-left: 20px;">
			<div class="d-flex pt-a">
				<div style="width: 33%;">
					<el-form-item label="订单号">
						<el-input :disabled="true" v-model="lists.bh" style="width: 90%;" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="临时状态">
						<el-switch v-model="lists.sfls" active-text="开启" inactive-text="关闭" :disabled="lists.id != 0 ? true : false"></el-switch>
					</el-form-item>
					<el-form-item label="还款人">
						<el-input v-model="lists.qrhkr" style="width: 90%;" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="是否支付">
						{{lists.zfzt == 1 ? '已支付' : '待支付'}}
					</el-form-item>
					<el-form-item label="是否通知">
						{{lists.sftz == 1 ? '已通知' : '待通知'}}
					</el-form-item>
					
				</div>
				
				<div style="width: 33%;">
					
					<el-form-item label="客户名称" v-if="lists.sfls == 0">
						<el-select v-model="lists.kh_id" filterable style="width: 90%;" size="mini" @change="curr" :disabled="lists.id != 0 ? true : false">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="临时客户" v-else>
						<el-input placeholder="请输客户姓名" v-model="lists.lsname" clearable size="mini" style="width: 96%;"></el-input>
					</el-form-item>
					
					<el-form-item label="支付人">
						<el-input v-model="lists.zfr" style="width: 90%;" size="mini"></el-input>
					</el-form-item>
					<el-form-item label="单据金额">
						<el-input-number size="mini" v-model="lists.zje" style="width: 90%;" :min='0' :precision="2"></el-input-number>
					</el-form-item>
					<el-form-item label="还款日期">
						<el-date-picker v-model="lists.qrhk_time" type="date" placeholder="开始时间" size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd"> </el-date-picker>
					</el-form-item>
					<el-form-item label="支付时间">
						{{lists.zf_time}}
					</el-form-item>
					<el-form-item label="通知时间">
						{{lists.tz_time}}
					</el-form-item>
					
				</div>
				
				
				<div style="width: 33%;">
					<el-form-item label="客户简称" v-if="lists.sfls == 0">
						<el-select v-model="lists.kh_id" filterable style="width: 90%;" size="mini" @change="curr" :disabled="lists.id != 0 ? true : false">
						    <el-option v-for="item in khlist" :key="item.id" :label="item.j_name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="临时电话" v-else>
						<el-input placeholder="请输手机号码" v-model="lists.lsphone" clearable size="mini" style="width: 96%;"></el-input>
					</el-form-item>
					<el-form-item label="货运方式">
						<el-select v-model="lists.hyfs" filterable style="width: 90%;" size="mini" @change="curr" :disabled="lists.id != 0 ? true : false">
						    <el-option v-for="item in hyfslist" :key="item.id" :label="item.name" :value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="备注">
						<el-input v-model="lists.desc" style="width: 95%;" type="textarea" :rows="2"></el-input>
					</el-form-item>
				</div>
			</div>
			
			<div style="border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  10px -6px;margin-bottom: 180px;">
				<div class="m-4 d-flex">
					<div>货物信息</div>
				</div>
				<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
				<div class="m-4">
					<el-table :data="djglhw" border style="width: 100%" key="tablec" size="mini" :header-cell-style="{ background: '#f0f1fa' }" >
						<el-table-column align="center" width="65" fixed="left">
							<template slot="header" slot-scope="scope">
								<el-button type="primary" size="mini" icon="el-icon-plus" @click="pustyl"></el-button>
							</template>
							<template slot-scope="scope">
								<el-button type="danger" size="mini" icon="el-icon-delete" @click="pustyldel(scope.$index)"></el-button>
							</template>
						</el-table-column>
						<el-table-column type="index" label="序号" width="80" align="center" fixed="left"></el-table-column>
						<el-table-column prop="hwmc" label="供货商" width="180">
							<template slot-scope="scope">
								<el-input size="mini" v-model="scope.row.ghs"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="hwmc" label="货物名称" width="180">
							<template slot-scope="scope">
								<el-input size="mini" v-model="scope.row.hwmc"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="件数" align="center" width="180">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.num" style="width: 90%;" :min='0'></el-input-number>
							</template>
						</el-table-column>
						<el-table-column label="运费金额(元)" align="center" width="180">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.yf" style="width: 90%;" :min='0' :precision="2" @change="handjstj"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="hwmc" label="备注">
							<template slot-scope="scope">
								<el-input size="mini" v-model="scope.row.desc"></el-input>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			
		</el-form>
		<el-button type="primary" style="position: fixed;bottom: 50px;right: 50px;" @click="submit">提交</el-button>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'; // 引入 全局 公共数据
	export default {
		inject: ['app', 'layout'],
		data() {
			return {
				lists: {},
				khlist:[],
				hyfslist:[],
				djglhw:[]
			};
		},
		computed: {
			...mapState({
				user: state => state.user.user
			})
		},
		// 生命周期
		created() {
			this.lists = this.$route.params.data;
			this.djglhw = this.lists.djglhw
			this.axios.get('/admin/khxxs', { token: true }).then(res => {
				this.khlist = res.data.data;
			});
			this.axios.get('/admin/thlx/1', { token: true }).then(res => {
				this.hyfslist = res.data.data.list;
			});
			
		},
		methods: {
			curr(val){
				let data = this.khlist.filter(item=>{
					return item.id == val
				})
			},
			
			pustyl() {
				if(!this.lists.kh_id){
					this.$message({
						type: "warning",
						message: "请先选择客户"
					})
				}else{
					let data = {
						hwmc:'',
						ghs:'',
						num:0,
						yf:0,
						desc:''
					}
					this.djglhw.push(data)
				}
			},
			pustyldel(e) {
				this.djglhw.splice(e,1)
				let yfs = 0
				for(let i of this.djglhw){
					yfs += i.yf
				}
				this.lists.zje = yfs
			},
			handjstj(){
				let yfs = 0
				for(let i of this.djglhw){
					yfs += i.yf
				}
				this.lists.zje = yfs
			},
			//提交
			submit() {
				if(this.jczt == '已存在'){
					this.$message({
						type: 'warning',
						message: '用户简称请勿重复使用'
					});
				}else{
					this.layout.showLoading();
					if (!this.lists.id) {
						this.lists.cjr = this.user.id
						this.lists.czr = this.user.id
						this.lists.jfpz_czr = this.user.id
					}else{
						this.lists.czr = this.user.id
					}
					let url = this.lists.id ? '/admin/dfdd/' + this.lists.id : '/admin/dfdd';
					this.lists.djglhw = this.djglhw
					this.axios
						.post(url, this.lists, {
							token: true
						})
						.then(res => {
							this.$message({
								type: 'success',
								message: this.id ? '修改成功' : '添加成功'
							});
							this.$router.push({
								name: 'djgl_ddcl_dfdd'
							});
							this.layout.hideLoading();
						})
						.catch(err => {
							this.layout.hideLoading();
						});
				}
				
			}
		}
	};
</script>

<style>
	.goods_create .el-form-item {
		margin-bottom: 15px;
	}

	.el-form-item__label {
		width: 84px !important;
	}

	.pt-a {
		padding-top: 20px;
	}
	
</style>